import React from 'react';
import { classNames } from '@panwds/react-ui';
import { useTableLayoutEnabled } from '../TableLayout/TableLayout.esm.js';
import '@panwds/icons';
import '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import 'uuid';
import 'react-intl';

function Header(props) {
    const tableLayoutEnabled = useTableLayoutEnabled();
    const { headerstyle } = props;
    const classes = classNames("tw-font-lato tw-border-solid tw-border-gray-300 tw-border-0 tw-sticky tw-top-0", tableLayoutEnabled && "tw-border-b dark:tw-border-gray-950");
    return (React.createElement("div", { role: "rowgroup", ...props, className: classes, style: headerstyle }));
}

export { Header };
//# sourceMappingURL=Header.esm.js.map
